<template >
  <div class="roleDialog">
    <el-dialog :title="title" :visible.sync="authDialogVisible">
      <div> {{ this.$props.name}}  </div>
      <el-tree
        :data="data2"
        show-checkbox
        node-key="id"
        :default-expanded-keys="[2, 3]"
        :default-checked-keys="[5]"
        :props="defaultProps">
      </el-tree>

      <div slot="footer" class="dialog-footer">
        <el-button @click="authDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
  import  {Message} from 'element-ui'
  export default {
      props: {
        id:{
          type: Number
        },
        name:{
          type: String
        },
        value: {
          type: Boolean,
          default () {
            return false;
          }
        }
      },
      data() {
        return {
          title: "角色授权",
          loading: false,
          data2: [{
            id: 1,
            label: '一级 1',
            children: [{
              id: 4,
              label: '二级 1-1',
              children: [{
                id: 9,
                label: '三级 1-1-1'
              }, {
                id: 10,
                label: '三级 1-1-2'
              }]
            }]
          }, {
            id: 2,
            label: '一级 2',
            children: [{
              id: 5,
              label: '二级 2-1'
            }, {
              id: 6,
              label: '二级 2-2'
            }]
          }, {
            id: 3,
            label: '一级 3',
            children: [{
              id: 7,
              label: '二级 3-1'
            }, {
              id: 8,
              label: '二级 3-2'
            }]
          }],
          defaultProps: {
            children: 'children',
            label: 'label'
          }
        }
      },
      methods:{
        // 加载页面初始化数据
        loadInitData(){

        },
        save(){
          this.loading = true;
          this.$refs.roleForm.validate(async valid => {
              //验证通过
              if (valid) {
                // 重置表单
                this.$refs.roleForm.resetFields();
                this.$emit("success")
                this.loading = false;
                this.authDialogVisible = false;
              }
            this.loading = false;
          });
        }
      },
     watch:{
       authDialogVisible(newVal ,oldVal){

          if(newVal && this.$refs.roleForm){
              this.roleForm={};
              this.$refs.roleForm.resetFields();
              // 加载初始化数据
              if(this.$props.id){
                this.loadInitData();
              }
          }
        }
      },
      computed: {
        authDialogVisible: {
          get () {
            return this.value;
          },
          set (val) {
            this.$emit('input', val);
          }
        }
      }
    };
</script>
<style scoped>

</style>
<style type="text/css">


</style>






// WEBPACK FOOTER //
// src/pages/admin/role-manage/authorize-dialog/index.vue